var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-easy-camera',{ref:"camera",on:{"close":_vm.onClose,"input":_vm.onSnap},model:{value:(_vm.picture),callback:function ($$v) {_vm.picture=$$v},expression:"picture"}})}
var staticRenderFns = []

export { render, staticRenderFns }